import { Number, Space, Text } from "components/common"
import Flex from "components/common/flex"
import ComparityModal from "features/reports/components/comparityModal"
import { useEffect, useState } from "react"
import { convertToHMSString, getOBJValueByKey } from "utils"
import UserReportHover from "../components/common/userReportHover/userReportHover"

export const useTableData = (dataRows = [], dataMapping, TableComponents, shouldTransformData) => {
  const [state, setState] = useState({ data: [], columns: [] })

  useEffect(() => {
    shouldTransformData && setTableData()
  }, [dataRows, dataRows?.length, dataMapping])

  const mapRowByColumns = (column, row, newRow) => {
    if (column.children) {
      column.children.forEach(childColumn => {
        newRow[childColumn.dataIndex] = mapRowByColumns(childColumn, row, newRow)
      })
    } else if (Array.isArray(column.component)) {
      return renderMultiType(column, row, newRow)
    } else if (column.component == "comparity") {
      return (
        <div style={{ width: 14 }}>
          <ComparityModal
            parentIndex={column?.parentIndex}
            dataIndex={column?.dataIndex}
            comparityValue={row?.["comparity"]?.[column.parentIndex]?.[column.dataIndex]}
            slopeValue={row?.["comparity"]?.[column.parentIndex]?.[column?.slopeKey]}
            rowData={row}
            colData={column}
            reportType={column?.from}
          />
        </div>
      )
    } else if (column.component === "string") {
      const value = getOBJValueByKey(row, column.dataKey)
      if (column?.color) {
        return <Text color={column?.color[value]}>{value}</Text>
      }
      return value
    } else if (column.component === "time") {
      return convertToHMSString(getOBJValueByKey(row, column.dataKey))
    } else if (column.component === "number") {
      return <Number value={getOBJValueByKey(row, column.dataKey)} />
    } else if (column.component === "hover") {
      let parentIndex = column?.parentIndex
      let data = row?.hoverInfo?.[parentIndex]
      return (
        <UserReportHover
          data={data?.[column?.dataIndex]}
          hoverKeys={column?.hoverKeys}
          message={<Number value={getOBJValueByKey(row, column.dataKey)} />}
        />
      )
    } else if (column.component === "currency") {
      return <Number isCurrency={false} value={getOBJValueByKey(row, column.dataKey)} />
    } else if (!!TableComponents?.[column?.component]) {
      const Component = TableComponents[column.component]
      return <Component {...getOBJValueByKey(row, column.dataKey, row)} subKey={column.dataIndex} />
    } else if (column.component === "target") {
      let achievedTargetTime = 0
      let totalTargetTime = 0
      let achievedTarget = 0
      let totalTarget = 0
      let percentage = 0

      if (column?.targetTypeValue === "time") {
        achievedTargetTime = convertToHMSString(+row[column.parentIndex][column.dataIndex])
        totalTargetTime = convertToHMSString(+row?.["targets"]?.[column.parentIndex]?.[column.dataIndex] ?? 0)
      }

      achievedTarget = Math.trunc(+row[column.parentIndex][column.dataIndex])
      totalTarget = Math.trunc(+row?.["targets"]?.[column.parentIndex]?.[column.dataIndex] ?? 0)
      percentage = Math.trunc((achievedTarget / totalTarget) * 100)

      return column?.targetType === "percentage"
        ? `${column?.targetTypeValue === "time" ? achievedTargetTime : achievedTarget} ${totalTarget ? `(${percentage}%)` : ""
        }`
        : totalTarget && column?.targetTypeValue === "time"
          ? `${achievedTargetTime} / ${totalTargetTime}`
          : totalTarget
            ? `${achievedTarget} / ${totalTarget}`
            : achievedTarget
    } else if (column.component == "ratio") {
      return getOBJValueByKey(row, column.dataKey)
    }
    else if (column.component == "showAddtionalValueAsPercentage") {
      return <Space direction="vertical" size={10}>
        <Number isCurrency={true} value={getOBJValueByKey(row, column.dataKey)} />
        <Number isCurrency={false} value={row?.["percentage"]?.[column.parentIndex]?.[column.dataIndex]} suffix={"%"} digitAfterFraction={0}/>
      </Space>
    }
    else {
      return row[column.dataIndex]
    }
  }
  const renderMultiType = (column, row, newRow) => {
    return (
      <Flex gap="6px" align="center" justify="center" wrap={false}>
        {column.component.map(type => {
          return mapRowByColumns({ ...column, component: type }, row, newRow)
        })}
      </Flex>
    )
  }
  const getRowData = item => {
    const obj = { ...item, key: item.key || item.id }
    dataMapping.forEach(column => {
      !column.children
        ? (obj[column.dataIndex] = mapRowByColumns(column, item, obj))
        : mapRowByColumns(column, item, obj)
    })
    if (!!item?.children) {
      obj.children = item.children.map(e => getRowData(e))
    }
    return obj
  }

  const setTableData = () => {
    if (dataRows && dataRows.length) {
      const tableData = []
      dataRows.forEach(item => {
        tableData.push(getRowData(item))
      })
      setState({
        columns: dataMapping.map(e => ({ ...e, dataKey: e.key })),
        data: tableData,
      })
    } else {
      setState(prevState => ({ data: [], columns: [] }))
    }
  }
  return shouldTransformData ? [state.data, state.columns] : [dataRows, dataMapping]
}
